"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncMap = void 0;
/**
 * A function to iterate over a list of items ensuring only
 * 'numberOfConcurrentPromises' items are processed at a time
 */
async function asyncMap(numberOfConcurrentPromises, itemsProvided, workerFunction) {
    const items = [...itemsProvided];
    const promises = [];
    for (let i = 0; i < items.length; i++) {
        let indexToInsertNewPromise = promises.length;
        if (indexToInsertNewPromise >= numberOfConcurrentPromises) {
            // If the promise array is at capacity wait for one to resolve
            indexToInsertNewPromise = await Promise.race(promises);
        }
        promises[indexToInsertNewPromise] = workerFunction(items[i], i).then(() => indexToInsertNewPromise);
    }
    return Promise.all(promises);
}
exports.asyncMap = asyncMap;
